import { useFlash } from 'contexts/flash';
import { useCallback, useEffect, useState } from 'react';
import {
  generatePreSeizure,
  getDetailPreSeizure,
  renderPayloadSeizure,
  updateDetailPreSeizure,
  updateStatusTransition
} from 'services/files';
import { useNavigate, useParams } from 'react-router-dom';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { FormPostSeizure } from 'app/pages/Admin/RedemptionPage/PostSeizurePage/components/modules/FormPostSeizure/FormPostSeizure';
import { isNull, omitBy } from 'lodash';
import axios from 'axios';
import { FilePostSeizureDetail } from '../../PostSeizurePage/Edit/hook';

export const useInjection = () => {
  const { setFlash } = useFlash();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dataDetail, setDataDetail] = useState<FormPostSeizure>();
  const fetchDetail = useCallback(async () => {
    const { filePreSeizure } = await getDetailPreSeizure(Number(id));
    const dataConvert = omitBy(filePreSeizure, isNull) as FilePostSeizureDetail;
    const formValue: FormPostSeizure = {
      fileId: Number(dataConvert.fileId),
      quickNote: dataConvert.quickNote,
      debtorDetail: {
        name: dataConvert.file?.firstName + ' ' + dataConvert.file?.lastName || '',
        address: dataConvert.addressLead?.id?.toString(),
        otherAddress: '',
        phoneNumber: dataConvert.phoneNumber || '',
        email: dataConvert.email || '',
        employer: dataConvert.employer || '',
        employerPhone: dataConvert.employerPhone || '',
        vin: dataConvert.file?.vin,
        fileNumber: dataConvert.file?.fileNumber
      },
      insuranceDetail: {
        provider: dataConvert.provider || '',
        policyNumber: dataConvert.policy || '',
        expiry: dataConvert.expiryDate ? new Date(dataConvert.expiryDate) : undefined
      },
      costDetail: {
        bailiffFees: dataConvert.bailiffFees,
        redemptionFees: dataConvert.redemptionFees,
        mvsFees: dataConvert.mvsSearch,
        arrears: dataConvert.arrears,
        arrearsTo: dataConvert.arrearsTo,
        clientFees: dataConvert.escFees,
        transportFees: dataConvert.transportFees || dataConvert?.transportFeesText || '',
        auctionFees: dataConvert?.auctionHouseFees || dataConvert?.auctionHouseFeesText || '',
        otherFeesIncurred: dataConvert.otherFeesIncurred || '',
        otherFees: dataConvert.otherFees
      },
      nextPaymentDetail: {
        nextPaymentDate: dataConvert.nextPaymentDate
          ? new Date(dataConvert.nextPaymentDate)
          : undefined,
        installmentAmount: dataConvert?.installmentAmount || undefined,
        frequency: dataConvert.frequency || ''
      },
      documents: dataConvert?.preSeizuresDocuments?.map((doc) => ({
        id: Number(doc.id),
        url: doc.url,
        name: doc.name,
        storageId: Number(doc.storageId)
      })),
      fileDocumentAdd: []
    };
    setDataDetail(formValue);
  }, [id]);
  const { asyncCallback: asyncFetchDetail } = useAsyncCallback(fetchDetail, [id]);
  useEffect(() => {
    asyncFetchDetail();
  }, [id]);

  const onSubmitUpdatePreSeizure = useCallback(
    async (formData: FormPostSeizure) => {
      const formData2 = new FormData();
      let filePhotosIds: number[] = [];
      const filePhotos = formData.fileDocumentAdd;
      if (filePhotos?.length) {
        for (let x = 0; x < filePhotos.length; x++) {
          formData2.append('files', filePhotos[x]!, filePhotos[x]!.name);
        }
        const { data: resListIdFile } = await axios.post(
          '/storages/pre_seizures_document',
          formData2,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        filePhotosIds = resListIdFile.files;
        formData2.delete('files');
      }
      const payload = renderPayloadSeizure(formData, [
        ...(formData?.documents?.map((item) => item.storageId) || []),
        ...filePhotosIds
      ]);
      await updateDetailPreSeizure(Number(id), payload);
      await fetchDetail();
      setFlash({ type: 'success', message: 'Update pre seizure successful' });
    },
    [fetchDetail, id, setFlash]
  );
  const { asyncCallback: asyncOnSubmitUpdatePreSeizure } = useAsyncCallback(
    onSubmitUpdatePreSeizure,
    []
  );
  const handleMoveToArchive = useCallback(async () => {
    await updateStatusTransition(Number(dataDetail?.fileId), 'CLOSE_REDEMPTION');
    setFlash({ type: 'success', message: 'Move to archive successful' });
    navigate('/admin/control-panel?tab=archive');
  }, [dataDetail?.fileId]);

  const handleGenerate = async (formData: FormPostSeizure) => {
    const formData2 = new FormData();
    let filePhotosIds: number[] = [];
    const filePhotos = formData.fileDocumentAdd;
    if (filePhotos?.length) {
      for (let x = 0; x < filePhotos.length; x++) {
        formData2.append('files', filePhotos[x]!, filePhotos[x]!.name);
      }
      const { data: resListIdFile } = await axios.post(
        '/storages/pre_seizures_document',
        formData2,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );
      filePhotosIds = resListIdFile.files;
      formData2.delete('files');
    }
    const payload = renderPayloadSeizure(formData, [
      ...(formData?.documents?.map((item) => item.storageId) || []),
      ...filePhotosIds
    ]);
    const data = await updateDetailPreSeizure(Number(id), payload);
    if (data.filePreSeizure.id) {
      await generatePreSeizure(data.filePreSeizure.id, payload);
      setFlash({ type: 'success', message: 'Generate successful' });
    }
    await fetchDetail();
  };
  const { asyncCallback: generateSeizure } = useAsyncCallback(handleGenerate, []);

  return {
    onSubmitUpdatePreSeizure: asyncOnSubmitUpdatePreSeizure,
    handleOnBack: () => navigate(`/admin/redemptions`),
    handleMoveToArchive,
    generateSeizure,
    dataDetail
  };
};
